module.exports = __webpack_public_path__ + "static/media/ajitminerals.ba5465be.PNG";